import React, { useEffect } from 'react';
import Hero from '@/components/Hero';
import BookingForm from '@/components/BookingForm';
import Services from '@/components/Services';
import VipSection from '@/components/VipSection';
import Fleet from '@/components/Fleet';
import Reviews from '@/components/Reviews';
import HowItWorks from '@/components/HowItWorks';
import FAQ from '@/components/FAQ';
import CTABanner from '@/components/CTABanner';
import Footer from '@/components/Footer';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import useIsMobile from '@/hooks/useIsMobile';

const REVEAL_INITIAL  = { opacity: 0, y: 30 };
const REVEAL_ANIMATE  = { opacity: 1, y: 0 };
const REVEAL_VIEWPORT = { once: true, margin: '-60px' };

const SectionReveal = ({ children, delay = 0 }) => {
  const isMobile = useIsMobile();
  if (isMobile) return <>{children}</>;
  return (
    <motion.div
      initial={REVEAL_INITIAL}
      whileInView={REVEAL_ANIMATE}
      viewport={REVEAL_VIEWPORT}
      transition={{ duration: 0.65, delay }}
    >
      {children}
    </motion.div>
  );
};

const HomePage = () => {
  const { t } = useTranslation();
  useEffect(() => {
    document.title = 'Taxi Porticcio 24h/24 | Chauffeur Privé Corse | Yellow Cab Corsica';
    const hash = window.location.hash.replace('#', '');
    if (hash) {
      setTimeout(() => {
        document.getElementById(hash)?.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    }
  }, []);

  return (
    <main className="bg-[#0A0A0A]">
      {/* Hero */}
      <Hero />

      {/* Booking Form */}
      <section id="reservation" className="bg-[#0A0A0A] py-16 px-4">
        <div className="max-w-3xl mx-auto">
          <SectionReveal>
            <div className="text-center mb-8">
              <p className="text-xs uppercase tracking-[0.2em] text-[#EAB308] font-semibold mb-3">{t('booking.label')}</p>
              <h2 className="text-3xl sm:text-4xl font-light text-white tracking-tight" style={{ fontFamily: 'Outfit, sans-serif' }}>
                {t('booking.title')}
              </h2>
              <p className="text-[#A3A3A3] mt-3 text-base">{t('booking.subtitle')}</p>
            </div>
            <BookingForm />
          </SectionReveal>
        </div>
      </section>

      {/* Services */}
      <SectionReveal>
        <Services />
      </SectionReveal>

      {/* VIP */}
      <SectionReveal>
        <VipSection />
      </SectionReveal>

      {/* Fleet */}
      <SectionReveal>
        <Fleet />
      </SectionReveal>

      {/* Reviews */}
      <SectionReveal>
        <Reviews />
      </SectionReveal>

      {/* How It Works */}
      <SectionReveal>
        <HowItWorks />
      </SectionReveal>

      {/* FAQ */}
      <SectionReveal>
        <FAQ />
      </SectionReveal>

      {/* CTA Banner */}
      <SectionReveal>
        <CTABanner />
      </SectionReveal>

      {/* Footer */}
      <Footer />

      {/* Spacer for sticky call bar */}
      <div className="h-16 md:h-14" aria-hidden="true" />
    </main>
  );
};

export default HomePage;
